module.exports = __webpack_public_path__ + "img/appIcon-menu--Applications.5958aabf.svg";